(() => {
  const fieldSelector = '#rsi_form_wrapper input, form[action="/cart"] input, form[action="/cart/"] input';
  const explicitControls = new Set(['button', 'submit', 'reset', 'checkbox', 'radio', 'file', 'image', 'range', 'color', 'hidden']);
  const preventImplicitCheckout = event => {
    if (event.key !== 'Enter' || event.isComposing || !(event.target instanceof HTMLInputElement)) return;
    if (!event.target.matches(fieldSelector) || explicitControls.has(event.target.type)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };
  for (const type of ['keydown', 'keypress', 'keyup']) {
    window.addEventListener(type, preventImplicitCheckout, true);
  }
})();

(() => {
  const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z]/g, '');
  const clear = () => {
    const city = document.querySelector('#rsi_form_wrapper input[name="city"]');
    if (city) city.setCustomValidity('');
    document.getElementById('pao-cod-city-error')?.remove();
  };
  const guard = event => {
    const wrapper = document.getElementById('rsi_form_wrapper');
    if (!wrapper) return;
    const city = wrapper.querySelector('input[name="city"]');
    const rate = wrapper.querySelector('input[name="shippingRate"]:checked');
    if (!city || !rate || !city.value.trim()) return;
    const value = normalize(city.value);
    const title = rate.closest('.rsi-shipping-rates-item')?.querySelector('.rsi-shipping-rates-title')?.textContent || '';
    let error = '';
    if (/^Livraison Berrechid/i.test(title) && value !== 'berrechid') error = 'La livraison gratuite à Berrechid est réservée à Berrechid. Choisissez le tarif correspondant à votre ville.';
    if (/^Livraison Casablanca/i.test(title) && value !== 'casablanca') error = 'Le tarif Casablanca est réservé à Casablanca. Choisissez le tarif correspondant à votre ville.';
    if (/^Livraison autres villes/i.test(title) && ['berrechid', 'casablanca'].includes(value)) error = 'Choisissez le tarif de livraison de ' + city.value.trim() + '.';
    clear();
    if (!error) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    city.setCustomValidity(error);
    const message = document.createElement('p');
    message.id = 'pao-cod-city-error';
    message.className = 'pao-cod-city-error';
    message.setAttribute('role', 'alert');
    message.textContent = error;
    city.parentElement.insertAdjacentElement('afterend', message);
    city.focus();
    city.reportValidity();
  };
  document.addEventListener('click', event => {
    if (event.target.closest('#rsi_form_wrapper .rsi-submit_button')) guard(event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.closest('#rsi_form_wrapper')) guard(event);
  }, true);
  for (const type of ['input', 'change']) document.addEventListener(type, event => {
    if (event.target.matches('#rsi_form_wrapper input[name="city"], #rsi_form_wrapper input[name="shippingRate"]')) clear();
  }, true);
})();